/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../cardr/issuing/model';
import '../../common/location';
import '../resources/card';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "ReissueCardRequest": {
                "fields": {
                  "cardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reasonCode": {
                    "type": ".squareup.cardr.issuing.ReissueCardReason",
                    "id": 2,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": ".squareup.common.location.Address",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ReissueCardResponse": {
                "fields": {
                  "card": {
                    "type": ".squareup.corporate_card.resources.Card",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ReissueCardRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ReissueCardResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ReissueCardRequest @ squareup/corporate_card/service/reissue_card.proto at 12:1
 */
export const ReissueCardRequest = $root.lookupType('squareup.corporate_card.service.ReissueCardRequest');
fixType(ReissueCardRequest, {
  cardToken: {
    required: true
  }
});
Builder.createAndAttachToType(ReissueCardRequest);
/**
 * SOURCE ReissueCardResponse @ squareup/corporate_card/service/reissue_card.proto at 29:1
 */
export const ReissueCardResponse = $root.lookupType('squareup.corporate_card.service.ReissueCardResponse');
fixType(ReissueCardResponse);
Builder.createAndAttachToType(ReissueCardResponse);